import Component from 'vue-class-component';
import { TjipFiltersMixin, tjipCurrencyFilter, tjipPercentFilter, tjipMomentFilter } from '@tjip/vuejs';
import { Mixins } from 'vue-property-decorator';
import * as humanize from 'humanize';
import { Risicoklasse } from '@/model/Risicoklasse';

const EVERY_FOUR_CHARS = /(.{4})(?!$)/g;
@Component({})
export class AppFiltersMixin extends Mixins(TjipFiltersMixin) {
  private static appCurrencyInteger(this: AppFiltersMixin, value: string | number) {
    return tjipCurrencyFilter.call(this, value, { maximumFractionDigits: 0 });
  }

  private static appPercent(this: AppFiltersMixin, value: string | number) {
    return tjipPercentFilter.call(this, value, { baseValue: 100, minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  private static appDate(this: AppFiltersMixin, value: string | Date) {
    return tjipMomentFilter.call(this, value, 'DD-MM-YYYY');
  }

  private static appFileSize(this: AppFiltersMixin, value: number) {
    return humanize.filesize(value, 1024, 0, ',', '.');
  }

  private static appIban(this: AppFiltersMixin, value: string) {
    return value.replace(EVERY_FOUR_CHARS, '$1 ');
  }

  private static appRisicoklasse(this: AppFiltersMixin, value: Risicoklasse): string {
    switch (value) {
      case Risicoklasse.KleinerDanOfGelijkAan50ProcentMarktwaarde:
        return 'Tot en met 50% van de marktwaarde van de woning';
      case Risicoklasse.KleinerDanOfGelijkAan65ProcentMarktwaarde:
        return 'Tot en met 65% van de marktwaarde van de woning';
      case Risicoklasse.Nhg:
        return 'NHG';
      case Risicoklasse.Gemeentegarantie:
        return 'Gemeentegarantie';
      default:
        return 'Onbekend';
    }
  }

  private static appHypotheekvorm(this: AppFiltersMixin, value: string): string {
    switch (value) {
      case 'Annuitair':
        return 'Annuïtair';
      case 'Spaarhypotheek':
        return 'Spaar-Optie-Hypotheek';
      case 'Levensverzekering':
        return 'Levenhypotheek';
      default:
        return value;
    }
  }

  private static appAflosvorm(this: AppFiltersMixin, value: string): string {
    switch (value) {
      case 'Annuitair':
        return 'Annuïtair';
      case 'Spaarhypotheek':
        return 'Spaar-Optie-Hypotheekverzekering';
      default:
        return value;
    }
  }

  protected beforeCreate() {
    this.$options.filters = Object.assign(
      {
        appCurrencyInteger: AppFiltersMixin.appCurrencyInteger.bind(this),
        appPercent: AppFiltersMixin.appPercent.bind(this),
        appDate: AppFiltersMixin.appDate.bind(this),
        appFileSize: AppFiltersMixin.appFileSize.bind(this),
        appRisicoklasse: AppFiltersMixin.appRisicoklasse.bind(this),
        appHypotheekvorm: AppFiltersMixin.appHypotheekvorm.bind(this),
        appAflosvorm: AppFiltersMixin.appAflosvorm.bind(this),
        appIban: AppFiltersMixin.appIban.bind(this)
      },
      this.$options.filters
    );
  }
}
